// extracted by mini-css-extract-plugin
export var fullScreenModal = "_redotech-redo-customer-portal-app-lib-portal-four-submission-components-portal-modal-full-screen-modal";
export var modal = "_redotech-redo-customer-portal-app-lib-portal-four-submission-components-portal-modal-modal";